
import moment from 'moment'

/***
 * Order mixins that are used in other component
 * 
 */
export const ordermixins = {
    data() {
        return {
             weekdays    : [],
             ordersummary: {
                subtotal  : '0.00',
                delivery  : '0.00',
                taxes     : '0.00',
                grandtotal: '0.00',
            },
            orderboxtype   : null
        }
    },
    filters : {
        /**
         * Format number with decimals
         */
        decimal(val) {
            return val ? val.toFixed(2).toString() : '0.00'
        }
    },
    computed : {
         /**
         * Settings from admin
         */
        settings() {
            return this.$store.state.settings
        },
        /**
         * check if subscription or order for event
         */
         issubscription(){
            return this.$store.state.issubscription
        },
         /**
         * Order types
         */
        ordertypes() {
            return this.$store.state.ordertypes
        },
        /**
         * Check if all boxes are completed
         * this will enable or disable buy button
         */
         orderboxescomplete() {
            const completed = this.orderboxes.filter(b => b.flavors.length == 12);

            return completed.length == this.orderboxes.length ? true : false;
        },
        /**
         * Get assorted boxtype
         */
         assortedbox() {
            const boxes    = this.ordertypes;
            const assorted = boxes.find(b => b.box_name.toLowerCase().match('assorted'));
            return assorted ? assorted : null;
        },
        /**
         * List of flavors
         */
         flavors() {
            return this.$store.state.flavors;
        },
         /**
         * Orderboxes
         */
        orderboxes : {
            get() {
                return this.$store.state.orderboxes
            },
            set(list) {
                this.$store.commit('updateorderboxes', list);
            }
        }
    },
    methods :  {
         /**
         * Set flag changing boxes
         */
          setflagboxchange(flag){
            const flags            = this.$store.state.editsubscriptionflags;

            if(flag == 'boxitem') {
                if(!flags.boxchanges) {
                    flags.boxchanges = true;
                    this.$store.commit('updateeditsubflag', flags)
                }
            } else if(flag == 'date') {
                if(!flags.datechanges) {
                    flags.datechanges = true;
                    this.$store.commit('updateeditsubflag', flags)
                }
            } else if(flag == 'reset') {
                flags.boxchanges  = false;
                flags.datechanges = false;
                this.$store.commit('updateeditsubflag', flags)
            }

        },  
        /**
         * Order for event 
         * get box type selected
         */
        getorderforeventboxtype() {
            const box = this.ordertypes.find(box => box.box_name.toLowerCase().indexOf(`${this.orderboxes.length}` && box.box_type == 'event'));
            this.orderboxtype = box;
        },
         /**
         * Get additional fees
         * Tax, and delivery fee
         */
        getfees() {
            const deliveryfee = this.settings.find(se => se.settings_field.match(/delivery/g));
            const taxes       = this.settings.find(se => se.settings_field.match(/tax/g));

            this.ordersummary.delivery = deliveryfee ? parseFloat(deliveryfee.settings_value).toFixed(2) : "0.00";
            this.ordersummary.taxes    = taxes ? parseFloat(taxes.settings_value).toFixed(2) : "0.00";
            

        },  
        /**
         * Get box price 
         * base on box type selected
         * @param {Object} order
         */
         getboxprice() {
            const boxsetting = this.issubscription ? this.settings.find(sett => sett.settings_field.match(/standard/g)) : this.settings.find(sett => sett.settings_field.match(/event/g));
            return boxsetting ? parseFloat(boxsetting.settings_value) : 0;
        },
        /**
         * Compute order summary 
         * 
         */
        computeordersummary() {
            // Get additional fees before doing some computation
            this.getfees();
            const boxprice  = parseFloat(this.getboxprice());
            const subtotal  = boxprice * this.orderboxes.length;
            const grandotal = subtotal + parseFloat(this.ordersummary.delivery) + parseFloat(this.ordersummary.taxes);

            this.ordersummary.subtotal   = subtotal.toFixed(2).toString();
            this.ordersummary.grandtotal = grandotal.toFixed(2).toString();
        },  
        /**
         * This will generate property with unique id
         * @param {Boolean} detfaultype  
         * @returns {Object} generated new box property
         */
        newboxproperty(detfaultype = false, type = 'subscription') {
            const [defaultboxtype] = this.ordertypes.filter(t => t.box_type == type);
            const flavors =  this.flavors;

            console.log('flavors', flavors);

            /**
             * (type) property will be remove in future so avoid using it
             * (price) property will be remove in future so avoid using it
             */
            return {
                id      : defaultboxtype ? defaultboxtype.id                     : 1,    // this will prevent confusion when updating array
                box_name: detfaultype && defaultboxtype ? defaultboxtype.box_name: '',
                type    : detfaultype && defaultboxtype ? defaultboxtype.id      : '',
                flavors : detfaultype && defaultboxtype ? flavors                : [],
                price   : detfaultype && defaultboxtype ? parseFloat(defaultboxtype.box_price)  : 0
            }
        },
        /**
         * Get dates from monday to friday
         */
         getweekdays(startingdate) {
            const startdate = startingdate ? moment(startingdate).utc().endOf('day') :  moment().endOf('day');
            let   dates     = [];

            console.log('startdate', startdate)

            /**
             * Check if startingdate date is weekend then don't include
             * 
             */
            if(startingdate && moment(startdate).day() != 0 && moment(startdate).day() != 6) {
                /**
                 * Check if startingdate is on same
                 */
                dates = [...dates, startdate];
            }


            for (let index = 1; index < 8 && dates.length < 5; index++) {

                /**
                 * check if Saturday or sunday
                 */
                const d = moment(startdate).add(index, 'days');

                if(d.day() != 6 && d.day() != 0) {
                    dates = [...dates, d]
                }
            }

            this.weekdays = dates;
        },
    }
} 